import GamesState from '../state/GamesState';
import Template from 'frontools/data/Template';
import ComponentAbstract from './ComponentAbstract';
import { autobind } from 'frontools/decorators/Autobind';
import GameAbstract from '../GameAbstract';

export default class GameScore extends ComponentAbstract {

    private _score              : number                    = 0;
    private _elScore            : HTMLElement;

    public static UPDATE        : string                    = 'update';

    constructor(startingScore: number = 0) {
        super();
        this._score = startingScore
        let tpl = new Template(document.querySelector('#tplScoreBoard') as HTMLElement, {}).htmlAsDOM.firstElementChild;
        this._elComponent = tpl as HTMLElement;
        GameAbstract.elGameWrapper.appendChild(this._elComponent);
        this._elScore = GameAbstract.elGameWrapper.querySelector('[data-js="score"]') as HTMLElement;

        this._render();
    }

    /*
     * add - Add points to current score
     * @param {number} number of points to add
     * 
     */
    public add(number: number) {
        this._score += number;

        this._render();

        this.dispatch({type: GameScore.UPDATE, score: this._score});
    };


    /*
     * remove -Remove points to current score
     * @param {number} number of points to remove
     * 
     */
    public remove(number: number) {
        let tempScore = this._score - number;
        this._score = tempScore <= 0 ? 0 : tempScore;

        this._render();

        this.dispatch({type: GameScore.UPDATE, score: this._score});        
    };


    /*
     * set - Force set a specific score
     * @param {number} number of points to set
     * 
     */
    public set(number: number) {
        this._score = number;

        this._render();

        this.dispatch({type: GameScore.UPDATE, score: this._score});
    };


    /*
     * _render - Countdown end handler
     * @param {number} time - current time to render
     * 
     */
    @autobind
    private _render() {
        this._elScore.innerText = String(this._score);
    };


    public get score(): number {
        return this._score;
    }


    /*
     * destroy - destroy this instance
     * 
     */
    public destroy() {
        super.destroy();
    };



    /*
     * _resize - handle resize
     * 
     */
    protected _resize(e) {
        super._resize(e);
    };

}

export class CountdownEvent {
    public static COMPLETE              : string                = 'complete';
}